import { createResource, type RouteResource } from 'react-resource-router';

import type { UserAccessRights } from '../../../common/mocks/user-access-rights/types';
import { getUserRights } from '../endpoints';

export const userAccessRightsResource: RouteResource<UserAccessRights> =
	createResource<UserAccessRights>({
		type: 'userAccessRightsResource',
		getKey: () => 'userAccessRightsResource',
		getData: (routerContext) => getUserRights(routerContext.match.params.teamId),
		maxAge: 10 * 60 * 1000, // 10 minutes
		isBrowserOnly: true,
	});
